module.exports = __webpack_public_path__ + "assets/img/kleptobreaker-logo--glow-15@2x.2867b250.png";